<script setup>
import { computed } from 'vue'
import { Copy } from 'lucide-vue-next'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { useQrCode } from '@/composables/useQrCode'

const props = defineProps({
  open: { type: Boolean, default: false },
  url: { type: String, default: '' },
  title: { type: String, default: 'Link' },
  description: { type: String, default: 'Scan to join.' },
})
const emit = defineEmits(['update:open', 'copy'])

const { svg } = useQrCode(() => props.url)
const displayUrl = computed(() => props.url.replace(/^https?:\/\//, ''))
</script>

<template>
  <Dialog :open="open" @update:open="emit('update:open', $event)">
    <DialogContent class="max-w-[520px]">
      <DialogHeader>
        <DialogTitle>{{ title }}</DialogTitle>
        <DialogDescription>{{ description }}</DialogDescription>
      </DialogHeader>

      <div
        class="mx-auto w-full max-w-[380px] rounded-2xl bg-white p-4 ring-1 ring-black/10 [&>svg]:h-auto [&>svg]:w-full"
        data-testid="qr-code"
        v-html="svg"
      ></div>
      <div class="flex items-center gap-2">
        <button
          type="button"
          class="flex min-h-9 min-w-0 flex-1 items-center gap-2 rounded-lg bg-muted px-3 py-2 text-left transition-colors hover:bg-muted/70"
          title="Copy"
          data-testid="qr-url"
          @click="emit('copy')"
        >
          <span class="min-w-0 flex-1 break-all font-mono text-xs leading-snug">{{ displayUrl }}</span>
          <span class="flex shrink-0 items-center gap-1 text-xs font-medium text-muted-foreground">
            <Copy class="size-4" />
            Copy
          </span>
        </button>
      </div>
    </DialogContent>
  </Dialog>
</template>
